import brand from "../product/brand.json"

export const getBrands = async () => {

    return brand;
    
};